import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

/**
 * Validate Privacy Level.
 */ function validatePrivacyLevel(privacyLevel) {
    return Object.values(DefaultPrivacyLevel).includes(privacyLevel);
}
/**
 * Create DataDog Rum.
 */ function createDatadogRum({ applicationId, clientToken, service, env, version, enableFeatureFlagTracking, privacyLevel = 'mask', overwriteConfig = {} }) {
    // Set Default Privacy Level
    const defaultPrivacyLevel = validatePrivacyLevel(privacyLevel) ? privacyLevel : 'mask';
    const enableExperimentalFeatures = [];
    if (enableFeatureFlagTracking) {
        enableExperimentalFeatures.push('feature_flags');
    }
    /**
     * Initialise DataDog Real User Monitoring.
     */ datadogRum.init({
        applicationId,
        clientToken,
        service,
        env,
        version,
        site: 'datadoghq.com',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel,
        enableExperimentalFeatures: enableExperimentalFeatures.length > 0 ? enableExperimentalFeatures : undefined,
        ...overwriteConfig
    });
    return datadogRum;
}
/**
 * DataDog Singleton Instance Ref.
 */ let datadogRumInstance;
/**
 * Initialize DataDog Run Instance (singleton).
 */ function datadogRumInit(props) {
    // Check if an instance exists
    if (datadogRumInstance == null) {
        // Create new instance if not exists
        datadogRumInstance = createDatadogRum(props);
    }
    // Return singleton instance
    return datadogRumInstance;
}
const datadogRumTrackFeatureFlagEvaluation = (key, value)=>{
    if (datadogRumInstance?.getInternalContext()?.application_id == null) {
        return;
    }
    datadogRumInstance.addFeatureFlagEvaluation(key, value);
};

export { datadogRumInit, datadogRumTrackFeatureFlagEvaluation };
//# sourceMappingURL=rum.js.map
